import FormType from "../../../../../Components/Form/FormType";
import Url from "../../../../../Services/Url";

const AddTemplateDetailsFormOptions = (init) => {
	return {
		Fields: [
			{
				element: FormType.Input,
				required: true,
				label: "Template Name",
				placeholder: "Enter template name",
				name: "name",
				value: init.name,
			},
			{
				element: FormType.Select,
				required: true,
				label: "Country",
				placeholder: "Select country ",
				options: { url: Url.contract.getContractCountries },
				name: "country",
				value: init.country,
			},
			{
				element: FormType.TextArea,
				required: true,
				label: "Use Case",
				placeholder: "Enter use case",
				name: "useCase",
				value: init.useCase,
			},
		],
	};
};

export default AddTemplateDetailsFormOptions;
